import { FC, useState, ChangeEvent } from "react";
import { makeStyles, Theme, useTheme } from "@material-ui/core/styles";
import { useStore, connect } from "src/store/connect";
import {
  FormControl,
  Select,
  MenuItem,
  TextField,
  InputLabel,
  Typography,
  Divider,
} from "@material-ui/core";

interface ItemProps {
  fieldName: string;
  initialValue: FormInputVariable;
  placeholder: string;
  variables: Variable[];
  onChange: (formInputVariable: FormInputVariable) => void;
}

const Item: FC<ItemProps> = ({
  fieldName,
  initialValue,
  placeholder,
  onChange,
  variables,
}) => {
  const classes = useStyles();
  const state = useStore();
  const [variableDefault, setVariableDefault] = useState<string>(
    initialValue.variableID === "" ? (initialValue.default as string) : ""
  );
  const [variableSelected, setVariableSelected] = useState<string>(
    initialValue.variableID
      ? state.flow.variables?.get(initialValue.variableID as string)?.id || ""
      : ""
  );

  const handleVariableOnChange = (
    event: ChangeEvent<{ name?: string; value: unknown }>
  ) => {
    const variableID = event.target.value as string;
    const formInputVariable: FormInputVariable = {
      variableID,
      default: "",
    };
    setVariableDefault("");

    setVariableSelected(variableID);
    onChange(formInputVariable);
  };

  const handlerDefaultOnChange = (event: ChangeEvent<HTMLInputElement>) => {
    setVariableDefault(event.target.value);

    const formInputVariable: FormInputVariable = {
      variableID: "",
      default: event.target.value,
    };
    onChange(formInputVariable);
  };

  const theme = useTheme();

  return (
    <div className={classes.root}>
      <div className={classes.fieldContainer}>
        <span className={classes.fieldSeparator} />
        <Typography className={classes.title}>{fieldName}</Typography>
      </div>
      <div className={classes.container}>
        <FormControl variant="filled" className={classes.selectInput}>
          <InputLabel>Variable</InputLabel>
          <Select
            value={variableSelected}
            onChange={handleVariableOnChange}
            disableUnderline={true}
            style={{ borderRadius: theme.spacing(2) }}
          >
            <MenuItem value="">
              <em>Ninguno</em>
            </MenuItem>
            {variables.map((variable) => {
              return (
                <MenuItem value={variable.id} key={variable.id}>
                  {variable.key}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
        <TextField
          className={classes.textfield}
          label="Valor por defecto"
          defaultValue={initialValue.default}
          value={variableDefault}
          onChange={handlerDefaultOnChange}
          placeholder={placeholder}
          variant="filled"
          autoComplete="off"
          InputLabelProps={{
            shrink: true,
          }}
          InputProps={{
            classes: {
              root: classes.textfield,
            },
            disableUnderline: true,
          }}
        />
      </div>
      <Divider className={classes.divider} />
    </div>
  );
};

Item.defaultProps = {};

export default connect(Item);

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    padding: "8px",
  },
  container: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    columnGap: theme.spacing(4),
  },
  divider: {
    margin: "20px 0",
  },
  textfield: {
    borderRadius: "10px",
    "& .MuiFilledInput-root": {
      background: "#fff",
      border: "solid 0.7px #CDD5E0",
      width: "100%",
      borderRadius: "2px",
    },
  },
  selectInput: {
    borderRadius: "10px",
    "& .MuiSelect-root": {
      background: "#fff",
      border: "solid 0.7px #CDD5E0",
      width: "100%",
      borderRadius: theme.spacing(2),
    },
  },
  title: {
    fontSize: "14px",
    fontWeight: 600,
    lineHeight: "21px",
  },
  fieldContainer: {
    display: "grid",
    alignItems: "center",
    gridTemplateColumns: "1fr 10fr",
    margin: "0 0 16px 0",
  },
  fieldSeparator: {
    width: "8px",
    height: "38px",
    borderRadius: "2.5px",
    backgroundColor: "#64DFEE",
  },
}));
